export class StatementFileImport {
  content?:string;
  filename?:string;


  constructor(filename: string, content: string) {
    this.content = content;
    this.filename = filename;
  }
}
